import { Section, TableOfContent } from '../../../typings/interfaces';
import { SPANISHLA } from '../../../assets/images';
// Spanish
const ESSection: Section[] = [
  {
    name: '1: Referencia y descripción general',
    subSections: [
      {
        name: 'Prólogo',
        page: 3,
      },
      {
        name: 'Finalidad y aplicaciones de la guía de campo',
        page: 4,
      },
      {
        name: 'Definiciones clave',
        page: 5,
      },
      {
        name: 'Jerarquía de los controles',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Vehículos motorizados - Seguridad vial',
        page: 9,
      },
      {
        name: 'Trabajo en altura',
        page: 12,
      },
      {
        name: 'Equipos Móviles (MPE)',
        page: 18,
      },
      {
        name: 'Bloqueo y etiquetado/Aislamiento de energía',
        page: 22,
      },
      {
        name: 'Trabajos eléctricos',
        page: 25,
      },
      {
        name: 'Espacios confinados',
        page: 29,
      },
      {
        name: 'Material a granel y almacenamiento',
        page: 32,
      },
      {
        name: 'Seguridad ferroviaria',
        page: 37,
      },
      {
        name: 'Trabajo de excavación y zanjado',
        page: 41,
      },
      {
        name: 'Elevación y aparejo',
        page: 45,
      },
      {
        name: 'Materiales peligrosos',
        page: 49,
      },
      {
        name: 'Trabajos en caliente',
        page: 52,
      },
    ],
  },
  {
    name: '3: Recursos adicionales y herramientas',
    subSections: [
      {
        name: 'Trabajar sobre y alrededor del agua',
        page: 56,
      },
      {
        name: 'Caída o desprendimiento de objetos',
        page: 59,
      },
      {
        name: 'Pruebas atmosféricas o de gas',
        page: 61,
      },
      {
        name: 'Comunicación de riesgos químicos',
        page: 65,
      },
    ],
  },
  {
    name: '4: Prácticas de gestión de seguridad de Cargill',
    subSections: [
      {
        name: 'Terminología principal',
        page: 70,
      },
      {
        name: 'Determinación de evento de lesión grave y fatalidad (SIF)',
        page: 72,
      },
      {
        name: 'Categorización de potencial de lesión grave y fatalidad (SIFp)',
        page: 73,
      },
      {
        name: 'Tabla de criterios de determinación automática de SIF',
        page: 74,
      },
      {
        name: 'Desempeño humano y organizacional (HOP)',
        page: 76,
      },
    ],
  },
];
const ESLTableofContent: TableOfContent = {
  language: 'esl',
  sections: ESSection,
  label: 'Tabla de contenidos',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide_SPANISH_LA_DIGITAL_CROPPED.pdf',
  hopPocket: 'Guía de bolsillo de HOP',
  hopPocketLink:
    'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Spanish (Latin America).pdf',
  source: SPANISHLA,
};

export default ESLTableofContent;
